import * as configureSolarApi from '../store/configureSolarApi';
import * as requestTypes from '../store/requestTypes';

const abschlagReducer = (state = {
    AbschlagUI: [],
    ...configureSolarApi.initialState
}, action) => {

    switch (action.type) {
        case "RECEIVE_AbschlagClass_abschlagReducer":
            return { ...state, AbschlagUI: action.value, isLoaded: true };
        // Bei forceRefresh: Alte Daten sofort leeren damit Chart Skeleton zeigt!
        case requestTypes.requestStartType.type:
            return { ...state, AbschlagUI: [], isLoaded: false };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default abschlagReducer;
